import { Observable } from 'rxjs';

export function observableNext<T>(obs: Observable<T>, cb: (T: T) => boolean | void | Promise<boolean | void>) {
  return new Promise<void>((res, rej) => {
    const subsc = obs.subscribe({
      next: async (v) => {
        if (await cb(v)) {
          subsc.unsubscribe();
          res();
        }
      },
      error: rej,
      complete: () => rej(new Error('Observable completed'))
    });
  });
}
